module.exports = __webpack_public_path__ + "noSidebar-6ef7bc970204e2607a4fddbb667094d6.png";